import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { getCacheData } from "../../services/CacheService";
import { getBlock, saveBlock } from "../../services/BlockService";
import { deleteFileBucket, getFileByUrl } from "../../services/BucketBackService";
import Message from "../../utils/Message";
import CodigoExternoDialog from "../dialogs/CodigoExternoDialog";
import FotoDialog from "../dialogs/FotoDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import { generaCodigo } from "../../utils/utils";

const initialState = {
  id: null,
  codigo: "",
  descripcion: "BLOCK",
  modelo: "",
  idBlockProducto: null,
  idBlCrAdicion: null,
  idBlCurva: null,
  idBlEspesor: null,
  idOjo: "",
  ubicacion: "",
  existenciaMinima: 0,
  puntoPedido: 0,
  existenciaMaxima: 0,
  codigoExterno: "",
  observaciones: "",
};

const ojoOptions = [
  {
    id: "izquierdo",
    label: "IZQUIERDO"
  },
  {
    id: "derecho",
    label: "DERECHO"
  },
  {
    id: "indistinto",
    label: "INDISTINTO"
  },
];

const nameItemsText = "Block";
//
// #############################################################################
//
const Block = () => {
  const params = useParams();
  const _idArticulo = params.idArticulo;
  const _action = params.action;
  const navigate = useNavigate();
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openCodigoExternoDialog, setOpenCodigoExternoDialog] = useState(false);
  const [openFotoDialog, setOpenFotoDialog] = useState(false);
  const [codigoExternoList, setCodigoExternoList] = useState([]);
  const [fotoList, setFotoList] = useState([]);
  const [actionCrud, setActionCrud] = useState("");
  const [itemCrud, setItemCrud] = useState(initialState);
  const [arrayFotos, setArrayFotos] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState({});
  const [titleComponent, setTitleComponent] = useState("");
  const [blockProductos, setBlockProductos] = useState([]);
  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const [blCurvas, setBlCurvas] = useState([]);
  const [blEspesores, setBlEspesores] = useState([]);
  const [valueACBlockProducto, setValueACBlockProducto] = useState(null);
  const [inputValueACBlockProducto, setInputValueACBlockProducto] = useState("");
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState(null);
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");
  const [valueACBlCurva, setValueACBlCurva] = useState(null);
  const [inputValueACBlCurva, setInputValueACBlCurva] = useState("");
  const [valueACBlEspesor, setValueACBlEspesor] = useState(null);
  const [inputValueACBlEspesor, setInputValueACBlEspesor] = useState("");
  const [valueACOjo, setValueACOjo] = useState(null);
  const [inputValueACOjo, setInputValueACOjo] = useState("");

  const tableColumnsCodigoExternoList = [
    {
      field: "descripcion_proveedor",
      headerName: "Proveedor",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.descripcion_proveedor}</span>
      ),
    },
    {
      field: "codigo_externo",
      headerName: "Código Externo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.codigo_externo}</span>
      ),
    },
    ...(_action !== "disable" && (actionCrud === "new" || actionCrud === "update") ? [{
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Tooltip title="Editar Código Externo">
            <IconButton
              size="small"
              aria-label="edit"
              onClick={() => handleClickCodigoExterno(params.row, "update")}
            >
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Quitar Código Externo">
            <IconButton
              size="small"
              aria-label="delete"
              onClick={() => handleClickCodigoExterno(params.row, "delete")}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    }] : []),
  ];

  const tableColumnsFotoList = [
    {
      field: "preview",
      headerName: "Vista Previa",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const archivo = params.row.archivo;
        let id_s3 = params.row.id_s3;
        let urlImg = getFileByUrl(id_s3);
        if (archivo !== undefined) {
          if (archivo.type.startsWith("image/")) {
            return (
              <img
                src={URL.createObjectURL(archivo)}
                alt="preview"
                style={{
                  width: 70,
                  height: 70,
                  objectFit: "cover",
                  borderRadius: "5px",
                  display: "block"
                }}
              />
            );
          } else {
            return <span>No disponible</span>;
          }
        } else {
          return (
            <img
              src={urlImg}
              alt="preview"
              style={{
                width: 70,
                height: 70,
                objectFit: "cover",
                borderRadius: "5px",
                display: "block"
              }}
            />
          );
        }
      },
    },
    ...(_action !== "disable" && (actionCrud === "new" || actionCrud === "update") ? [{
      field: "actions",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Quitar Foto">
          <IconButton
            size="small"
            aria-label="delete"
            onClick={() => handleClickFoto(params.row, "delete")}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      ),
    }] : []),
  ];

  const tableOptionsCodigoExternoList = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_proveedor,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  const tableOptionsFotoList = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || row.id_s3,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
        display: 'flex',
        alignItems: "center",
        padding: '8px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
      '& .MuiDataGrid-row': {
        minHeight: '120px !important',
        maxHeight: '120px !important',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      '& .MuiDataGrid-cell[data-field="preview"]': {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        padding: '4px',
        overflow: 'hidden',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    loadBlockProductos();
    loadBlCrAdiciones();
    loadBlCurvas();
    loadBlEspesores();

    if (_action === "new") {
      setTitleComponent("Nuevo " + nameItemsText);
      setItemCrudLocal({
        ...itemCrudLocal,
        codigo: generaCodigo(),
      });
    } else {
      load();
      setActionCrud(_action);
    }
  }, []);
  //
  // ################################################################################
  // 
  useEffect(() => {

    let _blockProducto = valueACBlockProducto ? valueACBlockProducto.label + " | " : "";
    let _blCurva = valueACBlCurva ? "CUR:" + Number(valueACBlCurva.label).toFixed(2) + " | " : "";
    let _blCrAdicion = valueACBlCrAdicion ? "ADI:" + Number(valueACBlCrAdicion.label).toFixed(2) + " | " : "";
    let _ojo = valueACOjo ? "OJO:" + valueACOjo.label : "";

    let _modelo = _blockProducto + _blCurva + _blCrAdicion + _ojo;

    setItemCrudLocal((prev) => ({
      ...prev,
      modelo: _modelo,
    }));
  }, [valueACBlockProducto, valueACBlCurva, valueACBlCrAdicion, valueACOjo]);
  //
  // ################################################################################
  //
  const loadBlockProductos = async () => {
    const response = await getCacheData("block_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlockProductos(_var);
    } else {
      setBlockProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor.toFixed(2)),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCurvas = async () => {
    const response = await getCacheData("bl_curva")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor.toFixed(2)),
        });
      });
      setBlCurvas(_var);
    } else {
      setBlCurvas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlEspesores = async () => {
    const response = await getCacheData("bl_espesor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor.toFixed(2)),
        });
      });
      setBlEspesores(_var);
    } else {
      setBlEspesores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/articulo/block-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickCodigoExterno = (itemCrud, action) => {
    let _itemCrud = {}

    if (action === "delete") {
      const updatedList = codigoExternoList.filter(
        (item) => item.id_proveedor !== itemCrud.id_proveedor
      );
      setCodigoExternoList(updatedList);
      return;
    }

    if (action === "update") {
      _itemCrud = {
        id: itemCrud.id ? itemCrud.id : uuid(),
        id_proveedor: itemCrud.id_proveedor,
        descripcion_proveedor: itemCrud.descripcion_proveedor,
        codigo_externo: itemCrud.codigo_externo,
      }
      setItemCrud(_itemCrud);
      setActionCrud(action);
      setOpenCodigoExternoDialog(true);
    } else {
      setActionCrud(action);
      setItemCrud(itemCrud);
      setOpenCodigoExternoDialog(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleClickFoto = (itemCrud, action) => {
    if (action === "delete") {
      const updatedList = fotoList.filter(
        (item) => item.id_s3 !== itemCrud.id_s3
      );
      deleteFileBucket(itemCrud.id_s3);
      setFotoList(updatedList);
      return;
    }
    setActionCrud(action);
    setOpenFotoDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async () => {

    if (itemCrudLocal.descripcion === "") {
      setMessage({
        messageText: "Debes ingresar alguna Descripción",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACBlockProducto) {
      setMessage({
        messageText: "Debes seleccionar el Producto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACBlCrAdicion) {
      setMessage({
        messageText: "Debes seleccionar la Adición",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACBlCurva) {
      setMessage({
        messageText: "Debes Seleccionar la Curva",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (!valueACBlEspesor) {
      setMessage({
        messageText: "Debes seleccionar el Espesor",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const _existenciaMinima = Math.max(0, +itemCrudLocal.existenciaMinima);
    const _puntoPedido = Math.max(0, +itemCrudLocal.puntoPedido);
    const _existenciaMaxima = Math.max(0, +itemCrudLocal.existenciaMaxima);

    if (_existenciaMinima > _puntoPedido || _puntoPedido > _existenciaMaxima) {
      setMessage({
        messageText: "Los valores de Existencia Mínima, Punto de Pedido y Existencia Máxima no son válidos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    let object = {};

    if (_action === "update") {
      object.id = itemCrudLocal.id;
    }

    object = {
      ...itemCrudLocal,
      codigo: itemCrudLocal.codigo,
      descripcion: itemCrudLocal.descripcion,
      modelo: itemCrudLocal.modelo.toUpperCase(),
      idBlockProducto: valueACBlockProducto.id,
      idBlCrAdicion: valueACBlCrAdicion.id,
      idBlCurva: valueACBlCurva.id,
      idBlEspesor: valueACBlEspesor.id,
      ojo: valueACOjo.id,
      ubicacion: itemCrudLocal.ubicacion.toUpperCase(),
      existenciaMinima: _existenciaMinima,
      puntoPedido: _puntoPedido,
      existenciaMaxima: _existenciaMaxima,
      lsCodigoExternoList: codigoExternoList ? codigoExternoList : [],
      lsFotoList: fotoList ? fotoList : [],
      observaciones: itemCrudLocal.observaciones.toUpperCase(),
    }

    setIsDoingSomething(true);
    const response = await saveBlock(_action, object);
    setIsDoingSomething(false);

    if (response.ok) {
      setTimeout(() => {
        navigate("/articulo/block-table");
      }, 500);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getBlock({ id: _idArticulo });
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;

      if (_action === "update") {
        setTitleComponent("Editando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText + ' ' + _response.codigo);
      } else if (_action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText + ' ' + _response.codigo);
      }

      let _codigoExternoList = _response.codigo_externo_list.map((item) => {
        return {
          id: item.id,
          id_proveedor: item.id_proveedor,
          descripcion_proveedor: item.descripcion_proveedor + (item.contacto_proveedor ? " - " + item.contacto_proveedor : ""),
          codigo_externo: item.codigo_externo,
        }
      });
      setCodigoExternoList(_codigoExternoList);

      let _fotoList = _response.foto_list.map((item) => {
        return {
          id: item.id,
          id_s3: item.id_s3

        }
      });
      setFotoList(_fotoList);

      setItemCrudLocal({
        ...itemCrudLocal,
        id: _response.id,
        codigo: _response.codigo,
        descripcion: _response.descripcion,
        modelo: _response.modelo,
        ubicacion: _response.ubicacion,
        existenciaMinima: _response.existencia_minima,
        puntoPedido: _response.punto_pedido,
        existenciaMaxima: _response.existencia_maxima,
        observaciones: _response.observaciones,
      });
      setValueACBlockProducto({
        id: _response.id_block_producto,
        label: _response.descripcion_block_producto,
      });
      setValueACBlCrAdicion({
        id: _response.id_bl_cr_adicion,
        label: String(_response.valor_bl_cr_adicion.toFixed(2)),
      });
      setValueACBlCurva({
        id: _response.id_bl_curva,
        label: String(_response.valor_bl_curva.toFixed(2)),
      });
      setValueACBlEspesor({
        id: _response.id_bl_espesor,
        label: String(_response.valor_bl_espesor.toFixed(2)),
      });
      setValueACOjo({
        id: _response.ojo,
        label: _response.ojo.toUpperCase(),
      });
    } else {
      setIsDoingSomething(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleCloseCodigoExternoDialog = () => {
    setOpenCodigoExternoDialog(false);
  }
  //
  // ################################################################################
  //
  const handleCloseFotoDialog = () => {
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################
  //
  const handleOnSaveCodigoExterno = (parItemCrud, parAction) => {
    let _codigoExternoList = [...codigoExternoList];
    if (parAction !== "delete") {
      let _existe = false
      _codigoExternoList.forEach((item) => {
        if (item.id_proveedor === parItemCrud.id_proveedor) {
          if (item.id !== parItemCrud.id) {
            _existe = true;
          }
        }
      });
      if (_existe) {
        setMessage({
          messageText: "Ya ha sido ingresado un Código Externo para el Proveedor seleccionado",
          severity: "error",
        });
        setShowMessage(true);
        return false;
      }
      if (parAction === "new") {
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        return true;
      } else {
        _codigoExternoList.splice(
          _codigoExternoList.findIndex((item) =>
            item.id_proveedor === parItemCrud.id_proveedor), 1)
        _codigoExternoList.push(parItemCrud)
        setCodigoExternoList(_codigoExternoList);
        setOpenCodigoExternoDialog(false);
        return true;
      }
    } else {
      _codigoExternoList.splice(_codigoExternoList.findIndex((item) =>
        item.id_proveedor === parItemCrud.id_proveedor), 1)
      setCodigoExternoList(_codigoExternoList);
    }
  }
  //
  // ################################################################################
  //
  const handleOnSaveFoto = (items) => {
    // Validar que no se excedan las 10 fotos
    if (fotoList.length + items.length > 10) {
      setMessage({
        messageText: `Solo se pueden ingresar un máximo de 10 fotos. Actualmente tienes ${fotoList.length} foto(s) y estás intentando agregar ${items.length} foto(s).`,
        severity: "error",
      });
      setShowMessage(true);
      return;
    }
    // busco dentro de fotoList si existe el id_s3
    let _varList = [...fotoList];
    let _existe = false;
    _varList.forEach((itemList) => {
      items.forEach((item) => {
        if (itemList.nombre === item.nombre) {
          _existe = true;
        }
      }
      );
    });
    if (_existe) {
      setMessage({
        messageText: "Al menos una de las fotos ya se encuentra en la lista",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    setFotoList(
      fotoList.concat(items)
    );
    setOpenFotoDialog(false);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {titleComponent}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={itemCrudLocal.codigo}
                  onChange={handleChange}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion ? itemCrudLocal.descripcion : ""}
                  onChange={handleChange}
                  // disabled={actionCrud === "disable" || actionCrud === "enable"}
                  disabled={true}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={8}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-bl-producto"
                  size="small"
                  value={
                    valueACBlockProducto && valueACBlockProducto.id
                      ? valueACBlockProducto
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlockProducto(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idBlockProducto: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlockProducto}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlockProducto(newInputValue);
                  }}
                  options={blockProductos}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Producto"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadBlockProductos();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-bl-cr-adicion"
                  size="small"
                  value={
                    valueACBlCrAdicion && valueACBlCrAdicion.id
                      ? valueACBlCrAdicion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrAdicion(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idBlCrAdicion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrAdicion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrAdicion(newInputValue);
                  }}
                  options={blCrAdiciones}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Adición"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadBlCrAdiciones();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-bl-curva"
                  size="small"
                  value={
                    valueACBlCurva && valueACBlCurva.id
                      ? valueACBlCurva
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCurva(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idBlCurva: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCurva}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCurva(newInputValue);
                  }}
                  options={blCurvas}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Curva"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadBlCurvas();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={4}>
                <Autocomplete
                  sx={{ width: "100%", pb: 1 }}
                  id="id-bl-espesor"
                  size="small"
                  value={
                    valueACBlEspesor && valueACBlEspesor.id
                      ? valueACBlEspesor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlEspesor(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idBlEspesor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlEspesor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlEspesor(newInputValue);
                  }}
                  options={blEspesores}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Espesor"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                // evita que abra/cierre el dropdown
                                e.stopPropagation();
                                loadBlEspesores();
                              }}
                              disabled={actionCrud === "disable" || actionCrud === "enable"}
                            >
                              <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={7} md={7} lg={4}>
                <Autocomplete
                  id="id-ojo"
                  size="small"
                  value={
                    valueACOjo && valueACOjo.id ? valueACOjo : null
                  }
                  onChange={(event, newValue) => {
                    setValueACOjo(newValue);
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      idOjo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACOjo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACOjo(newInputValue);
                  }}
                  options={ojoOptions}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Seleccione Ojo " />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={5}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="ubicacion"
                  label="Ubicación"
                  variant="outlined"
                  size="small"
                  name="ubicacion"
                  value={itemCrudLocal.ubicacion}
                  onChange={handleChange}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMinima"
                  label="Existencia Mínima"
                  variant="outlined"
                  size="small"
                  name="existenciaMinima"
                  value={itemCrudLocal.existenciaMinima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="puntoPedido"
                  label="Punto de Pedido"
                  variant="outlined"
                  size="small"
                  name="puntoPedido"
                  value={itemCrudLocal.puntoPedido}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <TextField
                  type="number"
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                    min: 0,
                    step: 1,
                    style: { textAlign: "center" },
                  }}
                  id="existenciaMaxima"
                  label="Existencia Máxima"
                  variant="outlined"
                  size="small"
                  name="existenciaMaxima"
                  value={itemCrudLocal.existenciaMaxima}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={12} lg={8}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="modelo"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="modelo"
                  value={itemCrudLocal.modelo}
                  onChange={handleChange}
                  disabled={true}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title="Ingresar Código Externo">
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickCodigoExterno({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                      >
                        Código externo
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <DataGrid
                    rows={codigoExternoList}
                    columns={tableColumnsCodigoExternoList}
                    {...tableOptionsCodigoExternoList}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                mx: 5,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(_action === "new" || _action === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Tooltip title={fotoList.length >= 10 ? "Máximo de 10 fotos alcanzado" : "Ingresar Foto"}>
                      <Button
                        className="btn-add-custom"
                        variant="contained"
                        onClick={() => handleClickFoto({}, "new")}
                        size="small"
                        sx={{ mb: 1, pb: 1, mt: 1 }}
                        disabled={fotoList.length >= 10}
                      >
                        Foto ({fotoList.length}/10)
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <Box sx={{
                    maxHeight: "380px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "center",
                    marginTop: "10px",
                    marginBottom: "5px",
                    position: "relative"
                  }}>
                    <DataGrid
                      rows={fotoList}
                      columns={tableColumnsFotoList}
                      {...tableOptionsFotoList}
                      sx={{ width: "100%" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ m: 1, mx: 5 }}>
              <Grid item xs={12} md={12} lg={4}>
                <TextField
                  inputProps={{
                    autoComplete: "off"
                  }}
                  id="observaciones"
                  label="Observaciones"
                  variant="outlined"
                  name="observaciones"
                  value={itemCrudLocal.observaciones}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: '80px',
                      minWidth: '400px',
                    }
                  }}
                  disabled={
                    actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Box>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", py: 1, pr: 5 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={_action === "disable" ? "error" : "primary"}
                  startIcon={
                    _action === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : _action === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {_action === "disable"
                    ? "Deshabilitar"
                    : _action === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelar}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Box>
        </Paper>
      </Paper >

      {openCodigoExternoDialog && (
        <CodigoExternoDialog
          onSave={handleOnSaveCodigoExterno}
          onClose={handleCloseCodigoExternoDialog}
          actionCrud={actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openFotoDialog && (
        <FotoDialog
          onSave={handleOnSaveFoto}
          onClose={handleCloseFotoDialog}
          actionCrud={actionCrud}
          arrayFotos={arrayFotos}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Block;
